import { makeStyles, shorthands } from "@fluentui/react-components";
export const useStyles = makeStyles({
  img: {
    maxWidth: "100%",
    ...shorthands.borderRadius("8px"),
  },

  title: {
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },

  link: {
    marginTop: "16px",
    color: "#006cac",
    ...shorthands.textDecoration("none"),
    fontStyle: "normal",
    fontWeight: 600,

    "&:hover": {
      ...shorthands.textDecoration("underline"),
    },
  },
  item: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "0px",

    "@media (max-width: 540px)": {
      flexBasis: "100%",
    },
  },
});
